<template>
  <div class="app" id="apps">
    <!--左侧筛选-->
    <div class="sunText">
      <div class="categoryAll">
        <div>{{msg ? msg.title :''}}</div>
      </div>
      <ul v-if="msg" style="list-style:none">
        <li v-for="(item,index) in msg.child" :key="index">
          <div class="category">{{item.title}}</div>
          <ul class="sunpop">
            <li
              @click="part(item2.id,item2.title,item.child)"
              v-for="(item2,index) in item.child"
              :key="index"
            >{{item2.title}}</li>
          </ul>
        </li>
      </ul>
    </div>
    <!--左侧筛选-->
    <div class="rightCont">
      <!--分类内容-->
      <div>
        <!--轮播图-->
        <div class="Rotary">
          <div id="myCarousel" class="carousel slide">
            <ol class="carousel-indicators navol">
              <li data-target="#myCarousel" data-slide-to="0" class="active spanMore"></li>
              <li data-target="#myCarousel" data-slide-to="1" class="spanMore"></li>
              <li data-target="#myCarousel" data-slide-to="2" class="spanMore"></li>
            </ol>
            <!-- Carousel items -->
            <div class="carousel-inner allImg" style="height:500px;">
              <div
                v-for="(itemimg,index) in RotaryImg"
                :class="index == 1 ? 'active' : ''"
                class="item"
                :key="index"
              >
                <img class="RotaryImg" :src="itemimg.url+'?x-oss-process=image/resize,w_1620'">
              </div>
            </div>
            <!-- Carousel nav -->
            <a class="navS carousel-control left" href="#myCarousel" data-slide="prev">
              <img src="../assets/out.svg" alt>
            </a>
            <a class="navS carousel-control right" href="#myCarousel" data-slide="next">
              <img src="../assets/more.svg" alt>
            </a>
          </div>
        </div>
        <!--轮播图-->
        <!--筛选内容-->
        <div class="Allpasges">
          <div class="classification">
            <div class="pages" v-if="videoNum">
              <span @click="listVideo(-1,'bool')">
                <img src="../assets/xiangzuo.svg" alt>
              </span>
              <span
                v-for="(item,index) in videoNum"
                :class="item ==  pagenum ? 'clickpage' : ''"
                @click="listVideo(item,'num')"
                :key="index"
              >{{item}}</span>
              <span @click="listVideo(1,'bool')">
                <img src="../assets/xiangyou.svg" alt>
              </span>
            </div>
            <div v-else></div>
            <div class="fication">
              <p v-for="(items,index) in clothesBuid" :key="index">
                <span
                  :class="items.id ==  clothesId ? 'ficationSapn' : ''"
                  @click="part(items.id,items.title,clothesBuid)"
                >{{items.title}}</span>
                <span v-if="index!= clothesBuid.length -1">/</span>
              </p>
            </div>
          </div>
          <div class="goodsAll">
            <div
              class="goods"
              v-for="(item,index) in clothesMsg"
              :key="index"
              v-if="index < 16"
              @click="details(item)"
            >
              <div>
                <img :src="item.img + '?x-oss-process=image/resize,h_600'">
              </div>
              <div>{{item.name}}</div>
              <div class="GoodsText">${{item.price / 5}} (￥{{item.price}})</div>
            </div>
          </div>
          <div class="classification">
            <div class="pages" v-if="videoNum">
              <span @click="listVideo(-1,'bool')">
                <img src="../assets/xiangzuo.svg" alt>
              </span>
              <span
                v-for="(item,index) in videoNum"
                :class="item ==  pagenum ? 'clickpage' : ''"
                @click="listVideo(item,'num')"
                :key="index"
              >{{item}}</span>
              <span @click="listVideo(1,'bool')">
                <img src="../assets/xiangyou.svg" alt>
              </span>
            </div>
            <div v-else></div>
          </div>
        </div>
        <!--筛选内容-->
      </div>
      <!--分类内容-->

      <!--详细内容-->
    </div>
  </div>
</template>

<script>
import Bus from "../bus/index";
export default {
  name: "integration",
  data() {
    return {
      msg: {},
      clothesMsg: {},
      clothesId: this.$route.query.bannerid ? +this.$route.query.bannerid : 23,
      clothesImg: [],
      clothesBuid: [],
      videoNum: null,
      allVideo: {},
      RotaryImg: [],
      pageindex: 16,
      pagenum: 1,
      // pageindex:
      classid: this.$route.query.id ? +this.$route.query.id : 0,
      bannerid: null,
      goodsall: JSON.parse(localStorage.getItem("goodsall")),
      goodspid: []
    };
  },
  created() {
    this.ShowMsg();
    // this.parts()
    this.listVideo(1);
    this.Rotary();

    var data = JSON.parse(localStorage.getItem("muenall"));
    this.msg = data[this.$route.query.id];
    this.clothesBuid = data[this.classid].child[0].child;
    // console.log("wo",document.body.offsetHeight);

    // console.log(a.offsetHeight);
  },
  methods: {
    //商品详情
    details(item) {
      console.log(item);
      this.$router.push({
        path: "/doc",
        // query: {"id":item.id,},
        query: { id: item.id, index: this.classid }
      });
    },
    // parts() {

    //   this.req.post('http://jd1.vvc.tw/index/goods/getMenuAll').then((res) => {
    //     if (res.data.code == 1) {
    //       this.msg = res.data.data[this.$route.query.id]
    //       this.clothesBuid=res.data.data[this.classid].child[0].child
    //     }
    //   })
    // },
    Rotary() {
      this.bannerid = +this.$route.query.id + 1;
      this.req
        .post(
          "http://jd1.vvc.tw/index/index/getBannerAll",
          this.qs.stringify({ status: this.bannerid })
        )
        .then(res => {
          this.RotaryImg = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    ShowMsg() {
      this.goodspid = [];
      var id = 23;
      if (this.$route.query.bannerid) {
        id = +this.$route.query.bannerid;
      }
      console.log(this.goodsall);

      for (let i = 0; i < this.goodsall.length; i++) {
        if (this.goodsall[i].pid == id) {
          this.goodspid.push(this.goodsall[i]);
        }
      }
      this.req
        .post(
          "http://jd1.vvc.tw/index/goods/getGoodsAll",
          this.qs.stringify({
            pid: id
          })
        )
        .then(res => {
          if (res.data.code == 1) {
            this.clothesMsg = res.data.data.data;
            this.videoNum = null;
            if (this.clothesMsg.length > 0) {
              this.videoNum = Math.ceil((this.clothesMsg.length + 1) / 16);
            } else {
              this.videoNum = null;
            }
            console.log(this.clothesMsg);
            for (var i in this.clothesMsg) {
              if (this.clothesMsg[i].img != "") {
                var sss = this.clothesMsg[i].img;
                this.clothesImg.push(sss[0]);
              }
            }
          }
        });
    },
    part(i, a, c) {
      this.clothesBuid = c;
      this.clothesId = i;
      // if(this.$route.query.bannerid){
      //   this.clothesId=+this.$route.query.bannerid
      // }
      console.log(111);
      this.req
        .post(
          "http://jd1.vvc.tw/index/goods/getGoodsAll",
          this.qs.stringify({
            pid: this.clothesId
          })
        )
        .then(res => {
          if (res.data.code == 1) {
            this.clothesMsg = res.data.data.data;
            console.log(this.clothesMsg);
            if (this.clothesMsg.length > 0) {
              this.videoNum = Math.ceil((this.clothesMsg.length + 1) / 16);
            } else {
              this.videoNum = null;
            }
            this.pagenum = 1;

            for (var i in this.clothesMsg) {
              if (!(JSON.parse(this.clothesMsg[i].img) == null)) {
                var sss = JSON.parse(this.clothesMsg[i].img);
                // this.clothesImg =  JSON.parse(this.clothesMsg[i].img)[0]
                this.clothesImg.push(sss[0]);
              }
            }
          }
        });
    },
    listVideo(a, status) {
      var boo = false;
      if (status == "bool") {
        this.pagenum += a;
        if (this.pagenum > this.videoNum) {
          this.pagenum = this.videoNum;
          boo = true;
        } else if (this.pagenum < 1) {
          this.pagenum = 1;
          boo = true;
        }
        // this.pagenum >= this.videoNum ? this.videoNum :''
        // this.pagenum <= 1 ? 1 :''
      }
      if (status == "num") {
        this.pagenum = +a;
      }
      if (boo) {
        return;
      }
      this.req
        .post(
          "http://jd1.vvc.tw/index/goods/getGoodsAll",
          this.qs.stringify({
            pages: this.pagenum,
            num: "16",
            pid: +this.$route.query.bannerid
          })
        )
        .then(res => {
          this.allVideo = res.data.data;
          this.clothesMsg = this.allVideo.data;
          for (var i in this.clothesMsg) {
            if (this.clothesMsg[i].img != "") {
              var sss = this.clothesMsg[i].img;
              // this.clothesImg =  JSON.parse(this.clothesMsg[i].img)[0]
              this.clothesImg.push(sss[0]);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    // 用$on事件来接收参数
    Bus.$on("val", data => {
      console.log(data);
      this.clothesMsg = data.data;
      this.clothesId = data.id;
      this.clothesBuid = data.clothesBuid;
      for (var i in this.clothesMsg) {
        if (this.clothesMsg[i].img != "") {
          var sss = this.clothesMsg[i].img;
          // this.clothesImg =  JSON.parse(this.clothesMsg[i].img)[0]
          this.clothesImg.push(sss[0]);
        }
      }
    });

    //  console.log("我",document.getElementById('apps'). scrollHeight) ;
    //  document.getElementById('apps').scrollTop = 0 +"px"
    // //  document.getElementById('apps').style.display='block'
    //  console.log(document.getElementById('apps').scrollTop)
    //  document.getElementById('apps').scrollHeight = 0;
    //  console.log("可可",document.body.scrollHeight) ;
  },
  computed: {},
  watch: {
    "$route.query.id"(to) {
      var data = JSON.parse(localStorage.getItem("muenall"));
      this.msg = data[this.$route.query.id];
      this.clothesBuid = data[this.classid].child[0].child;
      if (to == 1) {
        this.clothesId = this.$route.query.bannerid;
        this.bannerid = 2;
        this.classid = 1;
      } else if (to == 2) {
        this.clothesId = this.$route.query.bannerid;
        this.bannerid = 3;
        this.classid = 2;
      } else if (to == 0) {
        this.clothesId = this.$route.query.bannerid;
        this.bannerid = 1;
        this.classid = 0;
      } else {
      }
      this.listVideo(1);
      this.Rotary();
      this.ShowMsg();
      scroll(0, 0);
    }
  }
};
</script>

<style scoped lang="stylus">
ul li {
  list-style-type: none;
}

.navol {
  left: 150px;

  li {
    margin-left: 20px;
  }
}

.app {
  padding-top: 86px;
  max-width: 1920px;
  margin: 0 auto;
  position: relative;
  display: flex;
}

.spanMore {
  margn-left: 30px;
}

.carousel-inner {
  div {
    width: 1620px;
    height: 512px;

    // display flex
    // overflow hidden
    // align-items center
    // position relative
    img {
      width: 100%;
      height: auto;
      position: relative;
    }
  }
}

.left {
  left: 50px;
}

.right {
  right: 50px;
}

.Rotary {
  height: 512px;
}

// .RotaryImg
// width 1659px !important
// height 521px !important
.navS {
  width: 60px;
  height: 60px;
  background: transparent;
  opacity: 1;
  top: 49%;
  transform: translateY(0, -50%);
  line-height: 58px;

  img {
    width: 50px;
  }
}

.sunText {
  width: 300px;
  margin-top: 67px;
  padding-left: 40px;
  box-sizing: border-box;
}

.category {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 28px;
  margin: 20px 0 20px 0;
}

.categoryAll {
  div {
    margin-right: 40px;
    height: 82px;
    width: 230px;
    font-size: 30px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(74, 74, 74, 1);
    line-height: 82px;
    border-bottom: 1px solid rgba(87, 198, 235, 1);
  }
}

.sunpop {
  width: 220px;
  padding-bottom: 8px;
  border-bottom: 1px solid #57c6eb;

  li {
    height: 38px;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(74, 74, 74, 1);
    line-height: 38px;
    cursor: pointer;
  }
}

.classification {
  display: flex;
  justify-content: space-between;
  margin-top: 107px;
  margin-bottom: 42px;
  width: 1122px;
}

.fication {
  line-height: 48px;
  font-size: 24px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  display: flex;
  color: #C3C3C3;

  span {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
  }
}

.ficationSapn {
  color: rgba(87, 198, 235, 1);
}

.Allpasges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.pages {
  span {
    display: inline-block;
    font-size: 24px;
    text-align: center;
    font-family: SFUIText-Medium;
    font-weight: 500;
    color: rgba(74, 74, 74, 1);
    line-height: 48px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    margin: 0 12px;
  }

  .clickpage {
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 4px 0px rgba(153, 153, 153, 0.34), 0px -1px 3px 0px rgba(215, 215, 215, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}

.goodsAll {
  width: 1122px;
  display: flex;
  /* justify-content space-between */
  flex-wrap: wrap;
  align-content: flex-start;
}

.GoodsText {
  color: rgba(127, 127, 127, 1);
}

// .goods:hover{
// border  1px solid  red
// }
.goods {
  width: 219px;
  height: auto;
  margin-right: 82px;

  &:nth-child(4n) {
    margin-right: 0;
  }

  div {
    margin-top: 26px;
  }

  img {
    width: 219px;
  }
}

.pagetwo {
  width: 1122px;
  text-align: center;
}

.rightCont {
  border-left: 1px solid #57c6eb;
}

.allImg {
  img {
    width: 100%;
  }
}

.dity {
  display: flex;
}

.dityText {
  width: 368px;
  font-size: 22px;
  font-family: SFUIText-Regular;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}

.dityMoney {
  width: 205px;
  font-size: 24px;
  font-family: SFUIText-Medium;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
}

.dityTime {
  width: 449px;
  font-size: 12px;
  font-family: SFUIText-Medium;
  font-weight: 500;
  color: rgba(155, 155, 155, 1);
}

.selectOne, .selectTwo {
  width: 475px;
  height: 38px;
  border-radius: 2px;
  border: 2px solid rgba(215, 215, 215, 1);
}

.dity {
  margin-top: 49px;
  margin-left: 60px;
}

.ALldityText {
  margin-left: 27px;

  .buttondity {
    margin-bottom: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/integration.vue